export enum EnumScreenSections {
	comingUp = 'coming_up',
	pregame = 'pregame',
	live = 'live',
	whenTriviaStarts = 'when_trivia_starts',
	roundLTE3 = 'round_break_equal_or_less_than_3_minutes',
	roundEQ4 = 'round_break_equal_4_minutes',
	roundGTE5 = 'round_break_equal_or_greater_than_5_minutes',

	contestBreakPreGame = 'contest_break_pre_game',
	contestBreakPostGame = 'contest_break_post_game',
	contestBreakMidGame = 'contest_break_mid_game',

	postGame = 'post_game',
	round1 = 'break_between_first_and_second_round',
	round2 = 'break_between_second_and_third_round',
	round3 = 'break_between_third_and_fourth_round',
	round4 = 'break_between_fourth_and_fifth_round',
	round5 = 'break_between_fifth_and_sixth_round',
	round6 = 'break_between_sixth_and_seventh_rounds',
	ThreeMinOut = '3_mins_out',
	beforeLive = 'before_live',
}

export enum EnumThemes {
	Finals = 'finals',
	Blazin = 'blazin',
	Michelob = 'michelob',
	None = 'none'
}